export const S3_IMAGES_URL = 'https://static.solartrip.com/images/app_landing/';
export const S3_MP4_URL = 'https://static.solartrip.com/mp4/app_landing/';
export const APP_URL = 'https://slr.onelink.me/gEAA/e41twegr';
